import React from 'react';
import { CampaignTypeWithMappedPurpose } from '@mm/state/selectors/campaignSelectors';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { GreenMarker } from '../../../../../../common/components/GreenMarker/GreenMarker';
import { useGreenCueMarkers } from '../../../../../../common/hooks/use-green-cue-markers';
import { useFreeTrialUpgradeModal } from '../../../../../../common/modals/FreeTrialUpgradeModal/use-free-trial-upgrade-modal';

type Props = {
  purposeIsPromotional: boolean;
  savedCampaign: CampaignTypeWithMappedPurpose | undefined | null;
  savedCampaignCanceled: boolean;
  savedCampaignActive: boolean;
  savedCampaignPaused: boolean;
  disApprovedMessaging: boolean;
  setShowConfirmEndModal: (showConfirmEndModal: boolean) => void;
  onSaveCampaign: (alsoStart: boolean) => void;
  onSetPause: () => void;
  campaignErrors: string[];
  botIsTemplate: boolean;
  isRequesting: boolean;
};

const CampaignButtonsSection = (props: Props) => {
  const {
    campaignErrors,
    savedCampaignCanceled,
    savedCampaign,
    savedCampaignActive,
    savedCampaignPaused,
    setShowConfirmEndModal,
    onSaveCampaign,
    onSetPause,
    disApprovedMessaging,
    botIsTemplate,
    isRequesting,
  } = props;
  const campaignInvalid = !!campaignErrors.length;

  const { isFreeTrialPromotionWithoutSubscription } =
    useFreeTrialUpgradeModal();

  const { isDripCampaignsActivated } = useGreenCueMarkers();

  const showGreenCureMarker =
    isFreeTrialPromotionWithoutSubscription && !isDripCampaignsActivated;

  return (
    <div className="drip-campaign-detail__buttons-wrapper">
      {savedCampaign && savedCampaignActive && (
        <div className="drip-campaign-detail__buttons">
          <PrimaryButton
            color={ButtonColor.secondaryBlue}
            className="drip-campaign-detail__button"
            onClick={() => onSetPause()}
          >
            Pause
          </PrimaryButton>
          <PrimaryButton
            className="drip-campaign-detail__button"
            onClick={() => onSaveCampaign(false)}
            disabled={isRequesting || campaignInvalid}
          >
            Save
          </PrimaryButton>

          <PrimaryButton
            color={ButtonColor.invertedRed}
            className="drip-campaign-detail__button"
            onClick={() => setShowConfirmEndModal(true)}
          >
            End Campaign
          </PrimaryButton>
        </div>
      )}
      {!savedCampaignCanceled && (
        <div className="drip-campaign-detail__buttons">
          {!savedCampaignActive && (
            <PrimaryButton
              color={ButtonColor.secondaryBlue}
              className="drip-campaign-detail__button"
              onClick={() => onSaveCampaign(false)}
              disabled={isRequesting || campaignInvalid}
            >
              Save
            </PrimaryButton>
          )}
          {savedCampaignPaused && (
            <PrimaryButton
              color={ButtonColor.invertedRed}
              className="drip-campaign-detail__button"
              onClick={() => setShowConfirmEndModal(true)}
            >
              End Campaign
            </PrimaryButton>
          )}
          {!savedCampaignActive && (
            <PrimaryButton
              className="drip-campaign-detail__button"
              onClick={() => onSaveCampaign(true)}
              disabled={
                isRequesting ||
                campaignInvalid ||
                disApprovedMessaging ||
                botIsTemplate
              }
            >
              {savedCampaignPaused ? 'Save & Resume' : 'Start'}
            </PrimaryButton>
          )}
          {showGreenCureMarker && (
            <GreenMarker className="drip-campaign-details__buttons--green-marker" />
          )}
        </div>
      )}
    </div>
  );
};

export default CampaignButtonsSection;
